<template>
  <!-- 公告栏看板 -->
  <div class="mainWarp">
    <div class="img-title">
      <span class="DataTitle"></span>
      事件通知栏
    </div>
    <a-row class="headerUnit">
      <a-col :span="1"> </a-col>
      <a-col :span="11"><span>事件名称</span> </a-col>
      <a-col :span="12"><span style="margin-left: 28%">事件时间</span></a-col>
    </a-row>
    <div class="dataWarp" id="dataWarp" @scroll.prevent>
      <div class="ulDiv" id="ulDiv" @scroll.prevent>
        <div class="dataItem" @scroll.prevent v-for="(item, index) in dataList" :key="index">
          <span v-if="item.stateType !== 3" @click="Rowclicklu" class="dataItemTitle" style="color: #000000">
            {{ item.eventName }}
          </span>
          <span v-if="item.stateType == 3" @click="Rowclicklu" class="dataItemTitle" style="color: #ff0000">
            {{ item.eventName }}
          </span>
          <span class="dataItemTime" v-if="item.stateType !== 3" @click="Rowclicklu" style="color: #000000">{{
            item.createTime
          }}</span>
          <span class="dataItemTime" v-if="item.stateType == 3" @click="Rowclicklu" style="color: #ff0000">{{
            item.createTime
          }}</span>
        </div>
      </div>
      <div id="ulDiv2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BulletinBoard',
  components: {},
  data() {
    return {
      dataList: [],
      speed: 50,
      colee: '',
      colee1: '',
      colee2: '',
      leeonmo: false,
    }
  },
  created() {},
  mounted() {
    this.getKanbanData()(
      //自动刷新获取数据(1000*60*60=>毫秒*秒*分钟，此时表示为60分钟)
      (this.refreshData = setInterval(() => {
        var i = 1
        i++
        this.dataList = []
        this.leeonmo = true
        this.getKanbanData(i)
      }, 1000 * 60 * 2))
    )
  },
  methods: {
    Rowclicklu() {
      console.log('ppp')
      this.$router.push({ path: '/maintenance/event/managementt' })
    },
    getKanbanData(i) {
      const params = {
        sysType: '巡检',
      }
      this.$http.get('/pipe-network/tenant_events/list', { params }).then((res) => {
        res.data.map((item) => {
          this.dataList.push({
            eventName: item.eventName,
            createTime: item.createTime,
            stateType: item.stateType,
          })
        })
        console.log(this.dataList, 'gggggggg')
        if (this.dataList.length > 5) {
          this.$nextTick(() => {
            this.goScroll(i)
          })
        }
      })
    },
    goScroll() {
      let vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2
      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      if (this.leeonmo == false) {
        this.colee.onmouseover = function () {
          clearInterval(MyMar1)
        }
        this.colee.onmouseout = function () {
          MyMar1 = setInterval(() => {
            vm.Marquee1()
          }, vm.speed)
        }
      } else {
        clearInterval(MyMar1)((MyMar1 = null))
        this.colee.onmouseout = function () {
          MyMar1 = setInterval(() => {
            vm.Marquee1()
          }, vm.speed)
        }
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1() {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    },
  },
}
</script>

<style lang="less" scoped>
.headerUnit {
  width: 100%;
  height: 30px;
  // border-bottom-style:solid;
  // border-bottom: 1px solid rgb(35, 31, 31);
  background: #e7e9ec;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  justify-content: space-between;
  span {
    line-height: 30px;
    text-align: left;
    margin-left: 25px;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 16px;
    color: #1d1e1f;
  }
}
.mainWarp {
  height: 349px;
  width: 408px;
  background: url(~@/assets/myImg/h_1_02_box.png) no-repeat;
  background-size: contain;
  position: relative;
  // padding-left:20px;
  .img-title {
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 16px;
    color: #101010;
    letter-spacing: 0.63px;
    font-weight: 600;
    height: 40px;
    .DataTitle {
      width: 4px;
      height: 18px;
      margin-right: 10px;
      background: #0265ff;
      border-radius: 3px;
    }
  }
  .dataWarp {
    height: 192px;
    width: 100%;
    padding: 0 20px;
    overflow-x: hidden;
    background: #f7f9fd;
    .dataItem {
      width: 98%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      margin-top: 5px;
      .dataItemTitle {
        font-family: MicrosoftYaHeiSemibold;
        font-size: 16px;
        font-weight: 600;
        width: 120px;
        margin-left: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .dataItemTime {
        font-family: MicrosoftYaHei;
        font-size: 15px;
        text-align: right;
        font-weight: 400;
        margin-left: 10px;
        width: 70%;
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>
